module.exports = __webpack_public_path__ + "media/new-message.e7e5cdbf.mp3";